export const crosspostUserAgent = "ForumMagnum/2.1";
